module.exports = __webpack_public_path__ + "static/media/banner-refferal2.65aca882.png";